import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import { filterData } from "../../api/common";

ChartJS.register(ArcElement, Tooltip, Legend);

export function  CircularItems({data, startDate, endDate, title }) {

  
  //const [startDate, setStartDate] = useState("");
  //const [endDate, setEndDate] = useState("");
  const [chartData, setChartData] = useState(null);

  const fetchData = async () => {

    if (!startDate || !endDate) return;
    try {

      console.log(data)

      // Esperando respuesta tipo:
      // [{ _id: "Revisión", total: 51 }, { _id: "Abiertas", total: 32 }, ...]
      const labels = data.map(item => item._id);
      const values = data.map(item => item.total);

      setChartData({
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: [
              "#36A2EB", // puedes personalizar si quieres
              "#4BC0C0",
              "#FFCE56",
              "#FF6384",
              "#9966FF",
              "#FF9F40",
              "#C9CBCF",
            ],
          },
        ],
      });
    } catch (err) {
      console.error("Error cargando datos:", err);
    }
  };




  useEffect(() => {
    fetchData();
  }, [startDate, endDate,data]);

  return (

    <div className='chart-circular-container-main dashboard-item'>
    {/*<div style={{ width: "600px", margin: "auto" }}>*/}
     <span className='chart-header'>{title}</span>

      {/* Picker de fechas */}
      {/*<div style={{ display: "flex", gap: "1rem", margin: "1rem" }}>
        <div>
          <label>Desde: </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div>
          <label>Hasta: </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>*/}

      {/* Chart */}
      {chartData ? <Doughnut data={chartData} /> : <p>Selecciona un rango de fechas</p>}
    </div>
  );
};


